import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import "./NavbarOrganismMobile.css";
import NavButtonCollectionMobile from "../../molecules/navbuttoncollection/NavButtonCollectionMobile";
import { useState } from "react";

const NavbarOrganismMobile = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className="bg-body-tertiary py-0"
      expanded={expanded}
      onToggle={(expand) => setExpanded(expand)}
    >
      <Container fluid className="bg-set py-2">
        <Navbar.Brand className="fw-bold">STB-Portalen</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <NavButtonCollectionMobile onNavigate={() => setExpanded(false)}/>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarOrganismMobile;